import React from 'react';
import { Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SelectComponent from '@componentes/select/select.component';
import IntlMessage from '../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

const AdicionarLaminaPage = (props) => {
    const intl = useIntl()
    let disabled = props.blocos.length === 0 || props.bloco === null;
    return (
        <Modal size={'lg'} isOpen={props.open} toggle={props.toggle}>
            <div>
                <ModalHeader toggle={props.toggle}>
                    <IntlMessage id='dashboards.cytology.addBlades' />
                </ModalHeader>
                <ModalBody>
                    <div className="mv-laminas-detalhes">
                        <Row>
                            <Col sm={'3'}>
                                <FormGroup>
                                    <Label><IntlMessage id='dashboards.examDetail.numberOfExam' />:</Label>
                                    <Input
                                        disabled={props.blocos.length !== 0}
                                        className="fz-13"
                                        onChange={props.onChangeNrExame}
                                        onKeyPress={props.onKeyPressNrExame}
                                        value={props.nrExame}
                                        innerRef={props.nrExameRef} />
                                </FormGroup>
                            </Col>
                            <Col sm={'4'}>
                                <FormGroup>
                                    <Label><IntlMessage id='dashboards.examDetail.patient' /></Label>
                                    <Input
                                        disabled={true}
                                        className="fz-13"
                                        value={props.blocos.length>0? props.blocos[0].paciente: ''}/>
                                </FormGroup>
                            </Col>
                            {props.blocos.length>0 && props.blocos[0].pacienteNomeSocial && (
                            <Col sm={'4'}>
                                <FormGroup>
                                    <Label><IntlMessage id='dashboards.examDetails.socialName' /></Label>
                                    <Input
                                        disabled={true}
                                        className="fz-13"
                                        value={props.blocos.length>0? props.blocos[0].pacienteNomeSocial: ''}/>
                                </FormGroup>
                            </Col>)}
                            <Col>
                                <FormGroup>
                                    <Label><IntlMessage id="general.requestsPanel.block" /></Label>
                                    <SelectComponent
                                        disabled={props.blocos.length === 0}
                                        options={props.blocos}
                                        value={props.bloco}
                                        onChange={props.onChangeBlocos}
                                        placeholder={`${intl.formatMessage({ id: "dashboards.histology.selectBlocks" })}`} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="mv-tipo-laminas">
                            <Row>
                                {props.tipoLaminaBloco &&
                                    <Col>
                                        <div>
                                            <Row style={{ marginLeft: '10px' }}>
                                                <Col style={{ maxWidth: '75px' }}>
                                                    <Row>
                                                        <Col className="buttonAdd">
                                                            <i className="fas fa-chevron-left" onClick={() => !disabled && props.adicionarLaminaNoState(null, -1)} ></i>
                                                        </Col>
                                                        <Col className="inputLamina">
                                                            <Input
                                                                disabled={disabled}
                                                                type="text"
                                                                maxLength={2}
                                                                onKeyPress={props.onPressInput}
                                                                value={props.tipoLaminaBloco.qtd}
                                                                placeholder={"0"}
                                                                onChange={(event) => props.updateQtdLamina(null, event.currentTarget.value)}
                                                            ></Input>
                                                        </Col>
                                                        <Col className="buttonAdd">
                                                            <i className="fas fa-chevron-right" onClick={() => !disabled && props.adicionarLaminaNoState(null, +1)}></i>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col sm={'auto'} className='paddingLeft-1px'>
                                                    <Label>{props.tipoLaminaBloco.nome}</Label>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                }
                                <Col>
                                    <Row style={{ marginLeft: '10px' }}>
                                        <Col style={{ maxWidth: '75px' }}>
                                            <Row>
                                                <Col className="buttonAdd">
                                                    <i className="fas fa-chevron-left" onClick={() => !disabled && props.adicionarLaminaNoState('Recorte', -1)} ></i>
                                                </Col>
                                                <Col className="inputLamina">
                                                    <Input
                                                        disabled={disabled}
                                                        type="text"
                                                        maxLength={2}
                                                        onKeyPress={props.onPressInput}
                                                        value={props.qtdSentinelaRecorte}
                                                        placeholder={"0"}
                                                        onChange={(event) => props.updateQtdLamina('Recorte', event.currentTarget.value)}
                                                    ></Input>
                                                </Col>
                                                <Col className="buttonAdd">
                                                    <i className="fas fa-chevron-right" onClick={() => !disabled && props.adicionarLaminaNoState('Recorte', +1)}></i>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm={'auto'} className='paddingLeft-1px'>
                                            <Label><IntlMessage id='dashboards.histology.cutout' /></Label>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <div className="mv-tipo-laminas anticorpos">
                            <div className="box-title" style={{ width: '117px' }}>
                                <span style={{ width: '117px' }}><IntlMessage id='dashboards.histology.withAntibodies' /></span>
                            </div>
                            <Row>
                                <Col>
                                    <Row style={{ marginLeft: '10px' }}>
                                        <Col style={{ maxWidth: '75px' }}>
                                            <Row>
                                                <Col className="buttonAdd">
                                                    <i className="fas fa-chevron-left" onClick={() => !disabled && props.adicionarLaminaNoState('Col. Especial', -1)} ></i>
                                                </Col>
                                                <Col className="inputLamina">
                                                    <Input
                                                        disabled={disabled}
                                                        type="text"
                                                        maxLength={2}
                                                        onKeyPress={props.onPressInput}
                                                        value={props.qtdSentinelaColEspecial}
                                                        placeholder={"0"}
                                                        onChange={(event) => props.updateQtdLamina('Col. Especial', event.currentTarget.value)}
                                                    ></Input>
                                                </Col>
                                                <Col className="buttonAdd">
                                                    <i className="fas fa-chevron-right" onClick={() => !disabled && props.adicionarLaminaNoState('Col. Especial', +1)}></i>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm={'auto'} className='paddingLeft-1px'>
                                            <Label>Col. <IntlMessage id='dashboards.disposalMaterials.type.special' /></Label>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row style={{ marginLeft: '10px' }}>
                                        <Col style={{ maxWidth: '75px' }}>
                                            <Row>
                                                <Col className="buttonAdd">
                                                    <i className="fas fa-chevron-left" onClick={() => !disabled && props.adicionarLaminaNoState('Imuno', -1)} ></i>
                                                </Col>
                                                <Col className="inputLamina">
                                                    <Input
                                                        disabled={disabled}
                                                        type="text"
                                                        maxLength={2}
                                                        onKeyPress={props.onPressInput}
                                                        value={props.qtdSentinelaImuno}
                                                        placeholder={"0"}
                                                        onChange={(event) => props.updateQtdLamina('Imuno', event.currentTarget.value)}
                                                    ></Input>
                                                </Col>
                                                <Col className="buttonAdd">
                                                    <i className="fas fa-chevron-right" onClick={() => !disabled && props.adicionarLaminaNoState('Imuno', +1)}></i>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm={'auto'} className='paddingLeft-1px'>
                                            <Label><IntlMessage id='dashboards.taskControl.immune' /></Label>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row style={{ marginLeft: '10px' }}>
                                        <Col style={{ maxWidth: '75px' }}>
                                            <Row>
                                                <Col className="buttonAdd">
                                                    <i className="fas fa-chevron-left" onClick={() => !disabled && props.adicionarLaminaNoState('Fish', -1)} ></i>
                                                </Col>
                                                <Col className="inputLamina">
                                                    <Input
                                                        disabled={disabled}
                                                        type="text"
                                                        maxLength={2}
                                                        onKeyPress={props.onPressInput}
                                                        value={props.qtdFish}
                                                        placeholder={"0"}
                                                        onChange={(event) => props.updateQtdLamina('Fish', event.currentTarget.value)}
                                                    ></Input>
                                                </Col>
                                                <Col className="buttonAdd">
                                                    <i className="fas fa-chevron-right" onClick={() => !disabled && props.adicionarLaminaNoState('Fish', +1)}></i>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm={'auto'} className='paddingLeft-1px'>
                                            <Label><IntlMessage id='dashboards.examDetails.step.fish' /></Label>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col>
                                    <Row style={{ marginLeft: '10px' }}>
                                        <Col style={{ maxWidth: '75px' }}>
                                            <Row>
                                                <Col className="buttonAdd">
                                                    <i className="fas fa-chevron-left" onClick={() => !disabled && props.adicionarLaminaNoState('Cish', -1)} ></i>
                                                </Col>
                                                <Col className="inputLamina">
                                                    <Input
                                                        disabled={disabled}
                                                        type="text"
                                                        maxLength={2}
                                                        onKeyPress={props.onPressInput}
                                                        value={props.qtdCish}
                                                        placeholder={"0"}
                                                        onChange={(event) => props.updateQtdLamina('Cish', event.currentTarget.value)}
                                                    ></Input>
                                                </Col>
                                                <Col className="buttonAdd">
                                                    <i className="fas fa-chevron-right" onClick={() => !disabled && props.adicionarLaminaNoState('Cish', +1)}></i>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm={'auto'} className='paddingLeft-1px'>
                                            <Label><IntlMessage id='dashboards.examDetails.step.cish' /></Label>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        {
                            props.enableSentinela && <div className="mv-tipo-laminas sentinelas">
                                <div className="box-title" style={{ width: '83px' }}>
                                    <span style={{ width: '83px' }}><IntlMessage id='dashboards.histology.sentries' /></span>
                                </div>
                                <Row>
                                    {
                                        props.item.data.sentinelaMama === "S" && <Col>
                                            <Row style={{ marginLeft: '10px' }}>
                                                <Col style={{ maxWidth: '75px' }}>
                                                    <Row>
                                                        <Col className="buttonAdd">
                                                            <i className="fas fa-chevron-left" onClick={() => !disabled && props.adicionarLaminaNoState('Sentinela Mama', -1)} ></i>
                                                        </Col>
                                                        <Col className="inputLamina">
                                                            <Input
                                                                disabled={disabled}
                                                                type="text"
                                                                maxLength={2}
                                                                onKeyPress={props.onPressInput}
                                                                value={props.qtdSentinelaMama}
                                                                placeholder={"0"}
                                                                onChange={(event) => props.updateQtdLamina('Sentinela Mama', event.currentTarget.value)}
                                                            ></Input>
                                                        </Col>
                                                        <Col className="buttonAdd">
                                                            <i className="fas fa-chevron-right" onClick={() => !disabled && props.adicionarLaminaNoState('Sentinela Mama', +1)}></i>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col sm={'auto'} className='paddingLeft-1px'>
                                                    <Label>Mama</Label>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                    {
                                        props.item.data.sentinelaMelanoma === "S" && <Col>
                                            <Row style={{ marginLeft: '10px' }}>
                                                <Col style={{ maxWidth: '75px' }}>
                                                    <Row>
                                                        <Col className="buttonAdd">
                                                            <i className="fas fa-chevron-left" onClick={() => !disabled && props.adicionarLaminaNoState('Sentinela Melanoma', -1)} ></i>
                                                        </Col>
                                                        <Col className="inputLamina">
                                                            <Input
                                                                disabled={disabled}
                                                                type="text"
                                                                maxLength={2}
                                                                onKeyPress={props.onPressInput}
                                                                value={props.qtdSentinelaMelanoma}
                                                                placeholder={"0"}
                                                                onChange={(event) => props.updateQtdLamina('Sentinela Melanoma', event.currentTarget.value)}
                                                            ></Input>
                                                        </Col>
                                                        <Col className="buttonAdd">
                                                            <i className="fas fa-chevron-right" onClick={() => !disabled && props.adicionarLaminaNoState('Sentinela Melanoma', +1)}></i>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col sm={'auto'} className='paddingLeft-1px'>
                                                    <Label>Melanoma</Label>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        }
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label><IntlMessage id='dashboards.histology.sentries' />:</Label>
                                    <Input
                                        disabled={disabled}
                                        type="text"
                                        value={props.complemento}
                                        onChange={props.onChangeComplemento} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label><IntlMessage id='general.materialArchiving.technician' />:</Label>
                                    <SelectComponent
                                        disabled={disabled}
                                        options={props.tecnicos}
                                        value={props.tecnicoModalSelecionado}
                                        onChange={(event) => props.onChangeTecnicoModal(event)}
                                        placeholder={`${intl.formatMessage({ id: "dashboards.histology.selectBlocks" })}`} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label><IntlMessage id='dashboards.cytology.pathologist' />:</Label>
                                    <SelectComponent
                                        disabled={disabled}
                                        options={props.medicos}
                                        value={props.medicoSelecionado}
                                        onChange={(event) => props.onChangeMedico(event)}
                                        placeholder={`${intl.formatMessage({ id: "dashboards.examDetail.selectPathologist" })}`} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="mv-laminas-limpar">
                            <Button color="danger" onClick={props.limpar}>
                                <IntlMessage id='dashboards.histology.clean' />
                            </Button>
                        </div>
                        <div className="mv-laminas-adicionar">
                            <Button color="primary" onClick={props.adicionarLaminas}
                                disabled={props.validarCriacaoLamina()}
                            ><IntlMessage id='dashboards.cytology.toAddBlades' /></Button>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={props.toggle}><IntlMessage id='dashboards.disposalMaterials.modal.cancel' /></Button>
                </ModalFooter>
            </div>
        </Modal>
    )
}

export default AdicionarLaminaPage


// WEBPACK FOOTER //
// ./src/pages/histologia/common/modais/adicionar-lamina/adicionar-lamina.page.js